import React, { useState, useEffect } from "react";
import FormFields from "../../../form/FormFields";
import TabMobileButton from "../tab-mobile-button/TabMobileButton";
import { BlackAndWhite } from "../../../../../../themes/Colors";
import { TermsDisplay } from "./components";
import { BaseButtons, CloseButton } from "../../../../../../components/atoms";
import { ModalLayout } from "../../../../../store-owner-portal/components/reporting/components";
import { ImageUploadAWS } from "../../../../../../components";
import AWS from "aws-sdk";

const validFileTypes = ["image/jpg", "image/jpeg", "image/png"];

const Profile = ({
  selectedDisplay,
  profileProgress,
  customerName,
  patientNumber,
  firstName,
  lastName,
  idDoc,
  dateOfBirth,
  cellNumber,
  email,
  refreshHandler,
  loading,
  setValidateEdit,
  auth,
  prescriptionData,
  accountType,
  setLoading,
  setToastPop,
  setMessage,
  agreements,
  setAgreements,
  viewTerms,
  setViewTerms,
}) => {
  const [signedAt, setSignedAt] = useState("");

  const [recieptsPopUp, setRecieptsPopUp] = useState(false);

  const [receiptsArray, setReceiptsArray] = useState(null);

  const [selectedReceipt, setSelectedReceipt] = useState(null);

  const [userInfo, setUserInfo] = useState(true);

  const [section21Data, setSection21Data] = useState(null);

  const [imageDisplay, setImageDisplay] = useState(false);

  const [file, setFile] = useState(null);

  const [imageError, setImageError] = useState("");

  const [previewImage, setPreviewImage] = useState(null);

  const [imageLink, setImageLink] = useState("");
  const [imageData, setImageData] = useState(null);

  const getUplaodImage = async () => {
    const S3_BUCKET = process.env.REACT_APP_BUCKET;
    const apiKey = process.env.REACT_APP_AWS_ACCESS_KEY_ID;
    const secrectapiKey = process.env.REACT_APP_AWS_SECRET_KEY_ID;
    AWS.config.update({
      accessKeyId: apiKey,
      secretAccessKey: secrectapiKey,
    });
    const s3 = new AWS.S3({
      params: { Bucket: S3_BUCKET },
      region: process.env.REACT_APP_REGION,
      signatureVersion: "v4",
    });

    const params = {
      Bucket: S3_BUCKET,
      Key: `${auth.customerUserData.image}`,
    };

    var promise = s3.getSignedUrlPromise("getObject", params);
    // return promise;
    promise.then(
      function (url) {
        if (url) {
          setImageLink(url);
        }
        return url;
      },
      function (err) {
        console.log(err);
      }
    );
  };

  const handleFileChange = (e) => {
    // Uploaded file
    const file = e.target.files[0];
    // Changing file state
    setFile(file);
  };

  const AcceptAgreement = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        "https://budloungedatabase.onrender.com/user/acceptAgreements",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            signedAt: signedAt,
            email: email,
          }),
        }
      );
      const respnseData = await response.json();

      if (respnseData.success) {
        setLoading(false);
        setMessage(respnseData.success);
        setToastPop(true);
      } else {
        setLoading(false);
        setMessage(respnseData.message);
        setToastPop(true);
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };
  const getPatientReceipts = async () => {
    try {
      const response = await fetch(
        "https://budloungedatabase.onrender.com/processSale/getReciptForPatient",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            userId: auth.customerUserData.userId,
            idNumber: auth.customerUserData.idDoc,
          }),
        }
      );
      const respnseData = await response.json();

      if (respnseData.success) {
        setReceiptsArray(respnseData.receipts);
      }
    } catch (err) {
      console.log(err);
    }
  };

  // need to get section 21 application status and prescription to see if new script is needed
  const checkForSection21andPrescriptionStatus = async () => {
    try {
      const response = await fetch(
        "https://budloungedatabase.onrender.com/requestPrescriptionUser/getSection21ForPatientAndPrescriptions",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            patientId: auth.customerUserData.idDoc,
            patientUserId: auth.customerUserData.userId,
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.success) {
        setSection21Data(respnseData.section21);
      }
    } catch (err) {
      console.log("error", err);
    }
  };

  const uploadIdDoc = async (e) => {
    setLoading(true);

    if (!validFileTypes.find((type) => type === file.type)) {
      setImageError("File type must be JPG or PNG format");
      return;
    } else {
      setImageError("");
      setImageData(file);
    }
    try {
      const formData = new FormData();
      formData.append("image", file);
      formData.append("userId", auth.customerUserData.userId);
      formData.append("idDoc", auth.customerUserData.idDoc);

      const response = await fetch(
        "https://budloungedatabase.onrender.com" + "/user/uploadIdDoc",
        {
          method: "POST",
          body: formData,
        }
      );
      const respnseData = await response.json();

      if (respnseData.success) {
        setImageDisplay(false);
        setToastPop(true);
        setMessage(respnseData.success);

        setLoading(false);

        // setVehicleSearchArray(respnseData.enatisVehicles);
      } else {
        setToastPop(true);
        setMessage(respnseData.error);

        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      console.log("error", err);
    }
  };

  useEffect(() => {
    getPatientReceipts();
  }, [recieptsPopUp]);
  useEffect(() => {
    if (!file) {
      //   if (!sigfile) {
      //     return;
      //   }
      return;
    }
    const fileReader = new FileReader();
    fileReader.onload = () => {
      setPreviewImage(fileReader.result);
    };
    fileReader.readAsDataURL(file);
  }, [file]);
  useEffect(() => {
    if (auth && imageDisplay) {
      getUplaodImage();
    }
  }, [imageDisplay]);
  useEffect(() => {
    checkForSection21andPrescriptionStatus();
  }, []);
  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        backgroundColor: "#000000cc",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        position: "relative",
        //   justifyContent: "space-evenly",
      }}
    >
      <div
        style={{
          color: BlackAndWhite.secondary,
          minHeight: selectedDisplay ? 215 : 120,
          height: selectedDisplay ? 215 : 120,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          position: "relative",
          // backgroundColor: BlackAndWhite.primary,
        }}
      >
        <div
          style={{
            width: "100%",
            paddingBottom: 10,
            paddingTop: 10,
            backgroundColor: BlackAndWhite.red,
            color: "#000000",
            marginBottom: 10,
            // borderBottomLeftRadius: 20,
            // borderBottomRightRadius: 20,
            // minHeight: 40,
          }}
        >
          <div
            style={{
              marginLeft: 30,
              fontSize: 18,
              marginTop: 20,
              fontWeight: "bold",
              color: BlackAndWhite.secondary,
            }}
          >
            PROFILE
          </div>
        </div>
        <div
          style={{
            flex: 0.6,
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "row",
            marginTop: 10,
          }}
        >
          <div
            style={{
              width: 250,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: 80,
              fontSize: 18,
              // marginLeft: 20,
              flexDirection: "column",
              position: "relative",
              marginBottom: 10,
            }}
          >
            <div style={{ fontSize: 22 }}>{customerName}</div>
            {auth ? (
              auth.customerUserData.status ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <div
                    onClick={
                      auth.customerUserData.status === "Active"
                        ? null
                        : () => setValidateEdit(true)
                    }
                    style={{
                      // position: "absolute",
                      // bottom: 0,
                      // right: 0,
                      width: "100%",
                      fontSize: 14,
                      // borderStyle: "solid",
                      // height: 50,
                      borderRadius: 8,
                      marginTop: 15,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      // backgroundColor: "#48A14D",
                      borderWidth: 0.5,
                      // marginLeft: 50,
                      flexDirection: "column",
                    }}
                  >
                    STATUS:
                    <div style={{ fontSize: 20 }}>
                      {auth.customerUserData.status}
                    </div>
                  </div>
                  <div
                    style={{
                      // position: "absolute",
                      // bottom: 0,
                      // right: 0,
                      width: "100%",
                      fontSize: 14,
                      // borderStyle: "solid",
                      // height: 50,
                      borderRadius: 8,
                      marginTop: 15,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      // backgroundColor: "#48A14D",
                      borderWidth: 0.5,
                      // marginLeft: 50,
                      flexDirection: "column",
                    }}
                  >
                    SECTION 21 NO. :
                    <div style={{ fontSize: 20 }}>
                      {section21Data ? section21Data.status : "loading"}
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  onClick={() => setValidateEdit(true)}
                  style={{
                    // position: "absolute",
                    // bottom: 0,
                    // right: 0,
                    width: 180,
                    fontSize: 14,
                    borderStyle: "solid",
                    height: 30,
                    borderRadius: 8,
                    marginTop: 15,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "#B33F40",
                    borderWidth: 0.5,
                  }}
                >
                  Validate Account
                </div>
              )
            ) : (
              <div
                onClick={() => setValidateEdit(true)}
                style={{
                  // position: "absolute",
                  // bottom: 0,
                  // right: 0,
                  width: 180,
                  fontSize: 14,
                  borderStyle: "solid",
                  height: 30,
                  borderRadius: 8,
                  marginTop: 15,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "#48A14D",
                }}
              >
                Account Validated
              </div>
            )}
          </div>
        </div>
        {/* //refesh button */}
        <div
          style={{
            position: "absolute",
            top: 2,
            right: 2,
            backgroundColor: BlackAndWhite.primary,
            // borderRadius: "100%",
            zIndex: 100000000000000000,
          }}
        >
          <TabMobileButton
            icon={
              loading
                ? require("../../../../../../images/material-icons/loadingWhte.png")
                : require("../../../../../../images/material-icons/refreshwhite.png")
            }
            onClick={() => {
              refreshHandler();
            }}
            height={40}
          />
        </div>
      </div>
      {/* // recipets and store credit display */}
      <div
        style={{
          width: "100%",
          minHeight: 140,

          marginTop: 40,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          // marginBottom: 10,
        }}
      >
        <div
          style={{
            width: "100%",
            minHeight: "100%",
            height: "90%",
            backgroundColor: BlackAndWhite.secondary,

            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            // borderRadius: 8,
            overflow: "hidden",
          }}
        >
          <div
            style={{
              flex: 0.6,

              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{ fontSize: 24, fontWeight: "bold", marginBottom: 5 }}
              >
                {auth
                  ? Number(auth.customerUserData.rewardPoints).toFixed(2)
                  : "loading"}
              </div>
              <div style={{ fontWeight: "bold", fontSize: 14, opacity: 0.5 }}>
                STORE CREDIT
              </div>
            </div>
          </div>
          <div
            style={{
              flex: 0.4,
              height: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <BaseButtons
              mini={true}
              label={"BUY MORE"}
              disable={true}
              // borderRadius={8}
              marginTop={-1}
              marginTopFalse={true}
              size={"100%"}
              height={"50%"}
            />
            <BaseButtons
              mini={true}
              label={"RECEIPTS"}
              marginTopFalse={true}
              // disable={true}
              // borderRadius={8}
              marginTop={1}
              size={"100%"}
              height={"50%"}
              onClick={() => setRecieptsPopUp(true)}
            />
          </div>
        </div>
      </div>
      {/* tabs */}
      <div
        style={{
          width: "100%",
          minHeight: 40,
          backgroundColor: BlackAndWhite.secondary,
          marginTop: 2,
          display: "flex",
        }}
      >
        <BaseButtons
          mini={true}
          label={"USER INFO"}
          // disable={true}
          // borderRadius={8}
          marginTop={-1}
          marginTopFalse={true}
          size={"50%"}
          height={"100%"}
          onClick={() => setUserInfo(true)}
        />
        <BaseButtons
          mini={true}
          label={"HISTORY"}
          disable={true}
          // borderRadius={8}
          marginTop={-1}
          marginTopFalse={true}
          size={"50%"}
          height={"100%"}
        />
      </div>
      {userInfo ? (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <BaseButtons
            mini={true}
            label={"ID DOCUMENT"}
            // disable={true}
            // borderRadius={8}
            onClick={() => setImageDisplay(true)}
            marginTop={-1}
            marginTopFalse={true}
            size={"90%"}
            invert={true}
            height={40}
          />
        </div>
      ) : null}
      {userInfo ? (
        <FormFields
          selectedDisplay={selectedDisplay}
          patientNumber={patientNumber}
          firstName={firstName}
          lastName={lastName}
          idDoc={idDoc}
          dateOfBirth={dateOfBirth}
          cellNumber={cellNumber}
          email={email}
          profileProgress={profileProgress}
          accountType={accountType}
          onTermsClick={() => setViewTerms(true)}
          agreed={false}
          termsBackgroundColorButton={
            auth
              ? agreements
                ? agreements.length !== 0
                  ? BlackAndWhite.secondary
                  : "red"
                : "red"
              : "red"
          }
        />
      ) : null}

      <TermsDisplay
        terms={"social"}
        onCloseClick={() => setViewTerms(false)}
        display={viewTerms}
        isSigned={agreements ? (agreements.length !== 0 ? true : false) : false}
        userName={firstName + " " + lastName}
        signedAtAlready={
          auth
            ? agreements
              ? agreements.length !== 0
                ? agreements[0].signedAt
                : "loading"
              : "loading"
            : "loading"
        }
        isActive={
          auth
            ? agreements
              ? agreements.length !== 0
                ? true
                : false
              : false
            : false
        }
        dateCreated={
          auth
            ? agreements
              ? agreements.length !== 0
                ? agreements[0].dateCreated
                : "loading"
              : "loading"
            : "loading"
        }
        signedAt={signedAt}
        setSignedAt={setSignedAt}
        onAcceptClick={() => {
          AcceptAgreement();
          setViewTerms(false);
        }}
      />
      <ModalLayout
        display={recieptsPopUp}
        mobile={true}
        page={
          <div
            style={{
              flex: 1,
              backgroundColor: BlackAndWhite.secondary,
              height: "100%",
              display: "flex",
              flexDirection: "column",
              position: "relative",
              // borderBottomRightRadius: 20,
              // borderBottomLeftRadius: 20,
            }}
          >
            <div
              style={{
                position: "absolute",
                top: 20,
                left: 20,
                display: "flex",
                alignItems: "center",
              }}
            >
              {" "}
              <CloseButton
                label={"X"}
                onClick={() => setRecieptsPopUp(false)}
              />
            </div>
            <div
              style={{
                width: "100%",
                fontSize: 20,
                textAlign: "center",
                minHeight: 75,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div>TRANSACTION HISTORY</div>
            </div>
            <div
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "center",
                overflowY: "scroll",
                overflowX: "hidden",
              }}
            >
              {receiptsArray ? (
                receiptsArray.map((receipt, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div
                        onClick={() => setSelectedReceipt(receipt)}
                        style={{
                          minHeight: 160,
                          maxHeight: 160,
                          width: "90%",
                          marginTop: 10,
                          display: "flex",
                          flexDirection: "column",
                          borderRadius: 10,
                          overflow: "hidden",
                          WebkitBoxShadow: "0px 0px 7px 2px #00000030",
                        }}
                      >
                        <div style={{ marginLeft: 20, marginTop: 20 }}>
                          <div
                            style={{
                              fontSize: 10,
                              fontWeight: "bold",
                              opacity: 0.5,
                              marginBottom: 3,
                            }}
                          >
                            SLIP NO
                          </div>
                          <div style={{ fontSize: 14 }}>{receipt.slipNo}</div>
                        </div>
                        <div style={{ marginLeft: 20, marginTop: 10 }}>
                          <div
                            style={{
                              fontSize: 10,
                              fontWeight: "bold",
                              opacity: 0.5,
                              marginBottom: 3,
                            }}
                          >
                            STORE NAME
                          </div>
                          <div style={{ fontSize: 14 }}>
                            {receipt.storeName}
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            width: "100%",
                            alignItems: "center",
                            marginTop: 10,
                          }}
                        >
                          <div style={{ marginLeft: 20 }}>
                            <div
                              style={{
                                fontSize: 10,
                                fontWeight: "bold",
                                opacity: 0.5,
                                marginBottom: 3,
                              }}
                            >
                              CHANGE
                            </div>
                            <div style={{ fontSize: 16 }}>
                              R {Number(receipt.changeAmount).toFixed(2)}
                            </div>
                          </div>
                          <div style={{ flex: 1 }} />
                          <div style={{ marginRight: 20 }}>
                            <div
                              style={{
                                fontSize: 10,
                                fontWeight: "bold",
                                opacity: 0.5,
                                marginBottom: 3,
                              }}
                            >
                              TOTAL
                            </div>
                            <div style={{ fontSize: 16 }}>
                              R {Number(receipt.total).toFixed(2)}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div style={{ textAlign: "center", marginTop: 20 }}>
                  LOADING
                </div>
              )}
            </div>
          </div>
        }
      />
      <ModalLayout
        display={selectedReceipt}
        mobile={true}
        page={
          <div
            style={{
              flex: 1,
              backgroundColor: BlackAndWhite.secondary,
              height: "100%",
              display: "flex",
              flexDirection: "column",
              position: "relative",
              // borderBottomRightRadius: 20,
              // borderBottomLeftRadius: 20,
            }}
          >
            <div
              style={{
                position: "absolute",
                top: 20,
                left: 20,
                display: "flex",
                alignItems: "center",
              }}
            >
              {" "}
              <CloseButton
                label={"X"}
                onClick={() => setSelectedReceipt(null)}
              />
            </div>
            <div
              style={{
                width: "100%",
                fontSize: 20,
                textAlign: "center",
                minHeight: 75,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div>RECEIPT HISTORY</div>
            </div>
            <div
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "center",
                overflowY: "scroll",
                overflowX: "hidden",
              }}
            >
              <div style={{ marginTop: 20, width: "85%" }}>
                <div
                  style={{
                    fontSize: 10,
                    fontWeight: "bold",
                    opacity: 0.5,
                    marginBottom: 3,
                  }}
                >
                  SLIP NO
                </div>
                <div style={{ fontSize: 14 }}>
                  {selectedReceipt ? selectedReceipt.slipNo : "loading"}
                </div>
              </div>
              <div style={{ marginTop: 15, width: "85%" }}>
                <div
                  style={{
                    fontSize: 10,
                    fontWeight: "bold",
                    opacity: 0.5,
                    marginBottom: 3,
                  }}
                >
                  STORE
                </div>
                <div style={{ fontSize: 14 }}>
                  {selectedReceipt ? selectedReceipt.storeName : "loading"}
                </div>
              </div>
              <div style={{ marginTop: 15, width: "85%" }}>
                <div
                  style={{
                    fontSize: 10,
                    fontWeight: "bold",
                    opacity: 0.5,
                    marginBottom: 3,
                  }}
                >
                  ADDRESS
                </div>
                <div style={{ fontSize: 14 }}>
                  {selectedReceipt ? selectedReceipt.Address : "loading"}
                </div>
              </div>
              <div style={{ marginTop: 15, width: "85%" }}>
                <div
                  style={{
                    fontSize: 10,
                    fontWeight: "bold",
                    opacity: 0.5,
                    marginBottom: 3,
                  }}
                >
                  CONTACT NUMBER
                </div>
                <div style={{ fontSize: 14 }}>
                  {selectedReceipt ? selectedReceipt.contactNumber : "loading"}
                </div>
              </div>
              <div style={{ marginTop: 15, width: "85%" }}>
                <div
                  style={{
                    fontSize: 10,
                    fontWeight: "bold",
                    opacity: 0.5,
                    marginBottom: 3,
                  }}
                >
                  CASHIER
                </div>
                <div style={{ fontSize: 14 }}>
                  {selectedReceipt ? selectedReceipt.name : "loading"}
                </div>
              </div>
              <div style={{ marginTop: 15, width: "85%" }}>
                <div
                  style={{
                    fontSize: 10,
                    fontWeight: "bold",
                    opacity: 0.5,
                    marginBottom: 3,
                  }}
                >
                  DATE & TIME
                </div>
                <div style={{ fontSize: 14 }}>
                  {selectedReceipt
                    ? selectedReceipt.dateTime.substring(0, 10) +
                      " at " +
                      selectedReceipt.dateTime.substring(11, 16)
                    : "loading"}
                </div>
              </div>

              <div style={{ marginTop: 25, width: "85%" }}>
                <div
                  style={{
                    fontSize: 18,
                    fontWeight: "bold",
                    opacity: 0.9,
                    marginBottom: 3,
                  }}
                >
                  PURCHASED ITEMS
                </div>
              </div>
              {selectedReceipt
                ? selectedReceipt.productsArray.map((product, index) => {
                    return (
                      <div
                        key={index}
                        style={{
                          width: "90%",
                          minHeight: 100,
                          marginTop: index === 0 ? 20 : 30,
                          display: "flex",
                          alignItems: "center",
                          borderRadius: 8,
                          WebkitBoxShadow: "0px 0px 7px 2px #00000030",
                        }}
                      >
                        <div style={{ marginLeft: 10 }}>
                          <img
                            style={{ height: 60, width: 60 }}
                            alt="icon"
                            src={product ? product.product.imageUrl : null}
                          />
                        </div>
                        <div
                          style={{
                            marginLeft: 20,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            maxWidth: 120,
                            width: 120,
                          }}
                        >
                          <div
                            style={{
                              fontSize: 10,
                              fontWeight: "bold",
                              opacity: 0.5,
                              marginBottom: 3,
                              width: "100%",
                            }}
                          >
                            PRODUCT NAME
                          </div>
                          <div style={{ fontSize: 14, width: "100%" }}>
                            {product ? product.product.productName : null}
                          </div>
                        </div>
                        <div
                          style={{
                            marginLeft: 20,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          <div
                            style={{
                              fontSize: 10,
                              fontWeight: "bold",
                              opacity: 0.5,
                              marginBottom: 3,
                            }}
                          >
                            QTY
                          </div>
                          <div style={{ fontSize: 14 }}>
                            {product ? product.qtyCard.qty : null}
                          </div>
                        </div>
                        <div style={{ flex: 1 }} />
                        <div
                          style={{
                            marginRight: 20,
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <div
                            style={{
                              fontSize: 10,
                              fontWeight: "bold",
                              opacity: 0.5,
                              marginBottom: 3,
                            }}
                          >
                            TOTAL
                          </div>
                          <div style={{ fontSize: 14 }}>
                            R{" "}
                            {product
                              ? Number(
                                  product.product.retailPriceInc *
                                    product.qtyCard.qty
                                ).toFixed(2)
                              : null}
                          </div>
                        </div>
                      </div>
                    );
                  })
                : "loading"}

              <div style={{ marginTop: 30, width: "85%", display: "flex" }}>
                <div style={{ flex: 1 }} />
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div
                    style={{
                      fontSize: 16,
                      fontWeight: "bold",
                      opacity: 0.5,
                      // marginBottom: 3,
                      textAlign: "right",
                      marginRight: 10,
                    }}
                  >
                    SUB-TOTAL :
                  </div>
                  <div style={{ fontSize: 16, fontWeight: "bold" }}>
                    {selectedReceipt
                      ? "R " + Number(selectedReceipt.subTotal).toFixed(2)
                      : "loading"}
                  </div>
                </div>
              </div>
              <div
                style={{
                  marginTop: 25,
                  width: "85%",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div style={{ flex: 1 }} />
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div
                    style={{
                      fontSize: 16,
                      fontWeight: "bold",
                      opacity: 0.5,
                      // marginBottom: 3,
                      textAlign: "right",
                      marginRight: 10,
                    }}
                  >
                    VAT :
                  </div>
                  <div style={{ fontSize: 16, fontWeight: "bold" }}>
                    {selectedReceipt
                      ? "R " + Number(selectedReceipt.tax).toFixed(2)
                      : "loading"}
                  </div>
                </div>
              </div>
              <div
                style={{
                  marginTop: 25,
                  width: "85%",
                  display: "flex",
                  marginBottom: 20,
                }}
              >
                <div style={{ flex: 1 }} />
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div
                    style={{
                      fontSize: 16,
                      fontWeight: "bold",
                      opacity: 0.5,
                      // marginBottom: 3,
                      textAlign: "right",
                      marginRight: 10,
                    }}
                  >
                    TOTAL :
                  </div>
                  <div style={{ fontSize: 16, fontWeight: "bold" }}>
                    {selectedReceipt
                      ? "R " + Number(selectedReceipt.total).toFixed(2)
                      : "loading"}
                  </div>
                </div>
              </div>
              {/* <div style={{ marginTop: 25, width: "85%" }}>
                <div
                  style={{
                    fontSize: 18,
                    fontWeight: "bold",
                    opacity: 0.9,
                    marginBottom: 3,
                  }}
                >
                  PAYMENTS
                </div>
              </div> */}
            </div>
          </div>
        }
      />

      <ModalLayout
        display={imageDisplay}
        mobile={true}
        page={
          <div
            style={{
              flex: 1,
              backgroundColor: BlackAndWhite.secondary,
              height: "100%",
              display: "flex",
              flexDirection: "column",
              position: "relative",
              // borderBottomRightRadius: 20,
              // borderBottomLeftRadius: 20,
            }}
          >
            <div
              style={{
                position: "absolute",
                top: 20,
                left: 20,
                display: "flex",
                alignItems: "center",
              }}
            >
              <CloseButton label={"X"} onClick={() => setImageDisplay(false)} />
            </div>
            <div
              style={{
                flex: 0.8,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: 40,
              }}
            >
              <img
                alt="id doc"
                src={imageLink ? imageLink : previewImage}
                style={{ width: "90%" }}
              />
            </div>
            <ImageUploadAWS
              onChange={(e) => handleFileChange(e)}
              labelTitle={"UPLOAD IMAGE"}
              mini={true}
              errorDisplay={imageError}
            />
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <BaseButtons
                mini={true}
                label={"SUBMIT ID DOCUMENT"}
                size={"70%"}
                onClick={() => uploadIdDoc()}
              />
            </div>
          </div>
        }
      />
    </div>
  );
};

export default Profile;
